<template>
  <a :href="jobUrl" class="hp-job-card" :aria-label="cardLabel">
    <div class="hp-job-card__top">
      <JobCompanyLogo
        :company-name="job.company_name || job.job_designation"
        :logo-url="job.company_logo_url"
        root-class="hp-job-card__logo"
      />
      <div class="hp-job-card__actions">
        <div v-if="job.prem_stat" class="hp-job-card__badges">
          <span class="hp-job-card__badge hp-job-card__badge--premium">Premium</span>
        </div>
        <span class="hp-job-card__arrow" aria-hidden="true">→</span>
      </div>
    </div>
    <h3 class="hp-job-card__title">{{ job.job_designation }}</h3>
    <p v-if="job.company_name" class="hp-job-card__company">{{ job.company_name }}</p>
    <ul class="hp-job-card__meta">
      <li v-if="locationText">
        <v-icon size="14">{{ $icons.mapMarker }}</v-icon>
        <span>{{ locationText }}</span>
      </li>
      <li v-if="coursesText">
        <v-icon size="14">{{ $icons.school }}</v-icon>
        <span>{{ coursesText }}</span>
      </li>
      <li v-if="applyByText">
        <v-icon size="14">{{ $icons.calendarRange }}</v-icon>
        <span>{{ applyByText }}</span>
      </li>
      <li v-if="salaryText">
        <v-icon size="14">{{ $icons.cashMultiple }}</v-icon>
        <span>{{ salaryText }}</span>
      </li>
    </ul>
  </a>
</template>

<script>
import JobCompanyLogo from '@/components/JobCompanyLogo.vue';

export default {
  name: 'JobCardCompact',
  components: { JobCompanyLogo },
  props: {
    job: { type: Object, required: true },
  },
  computed: {
    jobUrl() {
      return `/jobs/${this.job.param}`;
    },
    cardLabel() {
      const title = this.job.job_designation || 'Job';
      return this.job.company_name ? `${title} at ${this.job.company_name}` : title;
    },
    locationText() {
      if (!this.job.cities || !this.job.cities.length) return '';
      const cities = this.job.cities.join(', ');
      return cities.length > 28 ? cities.slice(0, 28) + '…' : cities;
    },
    coursesText() {
      if (!this.job.courses || !this.job.courses.length) return '';
      const text = this.job.courses.map(c => c.name).join(', ');
      return text.length > 35 ? text.slice(0, 35) + '…' : text;
    },
    applyByText() {
      if (!this.job.last_date) return '';
      return `Apply by ${this.job.last_date}`;
    },
    salaryText() {
      if (this.job.salary_flag || !this.job.salary_range_from || this.job.salary_range_from <= 0) {
        return '';
      }
      let text = `₹${this.job.salary_range_from}`;
      if (this.job.salary_range_to) {
        text += ` – ₹${this.job.salary_range_to}`;
      }
      return `${text}/month`;
    },
  },
};
</script>
